import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';
import state from 'components/state';

const systemSettingsTabs = [
  { label: 'Feature Flags', value: 'feature-flags', permission: 'admin_feature_flag.read' }
];

const checkActive = (location) => {
  const path = location.pathname.split('/').pop();
  return systemSettingsTabs.find((tab) => tab.value === path) || systemSettingsTabs[0];
};

const switchTabs = (item, navigate) => {
  navigate(item.value);
};

const DevSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = useRecoilValue(state.permissions);

  const availableTabs = systemSettingsTabs.filter((tab) => pm(permissions, tab.permission));
  return (
    <div className="flex h-full flex-col">
      <Outlet
        context={{
          switchTabs,
          toggleSwitch: (
            <ToggleSwitch
              items={availableTabs}
              onClick={(item) => switchTabs(item, navigate)}
              active={checkActive(location)?.value}
            />
          )
        }}
      />
    </div>
  );
};

export default withErrorBoundary(DevSettings);
